// Does the current user hold a PESTEL seat in the active workspace?
//
// PESTEL access is granted here, in Settings -> PESTEL Access, but it is stored
// in the PESTEL backend — Regul has no local copy to consult. So we ask PESTEL,
// with the acting user's Regul token, and use the answer to decide whether to
// offer the PESTEL entry at all.
//
// This is presentation only. The real gate is PESTEL's `POST /auth/sso`, which
// re-checks the grant before it issues a session; hiding the button just spares
// people a door that would not open.
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import pestelApi from 'utils/pestelApi'

export default function usePestelAccess() {
  const authToken = useSelector(state => state.auth.authToken)
  const activeWorkspace = useSelector(state => state.auth.activeWorkspace)
  const workspaceId = activeWorkspace ? activeWorkspace.id : null

  const [hasAccess, setHasAccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    if (!authToken || !workspaceId) {
      setHasAccess(false)
      return undefined
    }
    setIsLoading(true)
    pestelApi.get(`/workspaces/${workspaceId}/my-access`)
      .then((res) => {
        if (!cancelled) setHasAccess(!!(res.data && res.data.has_access))
      })
      .catch(() => {
        // PESTEL unreachable, or the workspace has no PESTEL space yet. Hiding
        // the entry is the safe default: showing it would promise a hand-off we
        // have no reason to think will succeed.
        if (!cancelled) setHasAccess(false)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => { cancelled = true }
  }, [authToken, workspaceId])

  return { hasAccess, isLoading }
}
